import { motion } from "framer-motion";
import { ReactNode } from "react";
import { Link } from "react-router-dom";

interface GlowCardProps {
  children: ReactNode;
  to: string;
  index: number;
}

export const GlowCard = ({ children, to, index }: GlowCardProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{
        delay: index * 0.08,
        duration: 0.4,
        ease: "easeOut"
      }}
      className="relative h-full"
    >
      <Link
        to={to}
        className="group block relative backdrop-blur-md bg-gradient-to-br from-accent/5 to-accent/[0.02] border border-border/40 rounded-2xl p-4 sm:p-5 min-h-[160px] sm:min-h-[180px] hover:border-accent/50 transition-all duration-300 shadow-[0_4px_16px_rgba(0,0,0,0.1)] hover:shadow-[0_8px_24px_rgba(0,0,0,0.15),0_0_20px_rgba(139,195,74,0.1)] flex flex-col justify-center items-center text-center overflow-hidden isolate"
      >
        {/* Subtle Glow Effect - Only on Hover */}
        <div className="absolute inset-0 bg-accent/0 group-hover:bg-accent/[0.08] rounded-2xl blur-2xl pointer-events-none transition-all duration-500 -z-10" />
        
        <div className="relative z-10">
          {children}
        </div>
      </Link>
    </motion.div>
  );
};
